import {Parser} from "./AbstractParser";

export class DateParser extends Parser {
    constructor(input, separator, format) {
        super(input);
        this.separator = separator;
        this.format = format;
    };
    parse() {
        var fromString = (input) => ({
            year: input.slice(6, 10),
            month: input.slice(3, 5),
            day: input.slice(0, 2)
        });
        var fromStringfiedNumber = (input) => ({
            year: input.slice(4),
            month: input.slice(2, 4),
            day: input.slice(0, 2)
        });
        var fromNumber = (input) => ({
            year: input.toString().slice(4, 8),
            month: input.toString().slice(2, 4),
            day: input.toString().slice(0, 2)
        });
        var fromObject = (input) => {
            let date = typeof input === "number" ? new Date(input) : input;
            return {
                year: date.getFullYear(),
                month: (date.getMonth() + 1).toString().length === 1 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1,
                day: date.getDate().toString().length === 1 ? "0" + date.getDate() : date.getDate()
            }
        };
        let obj;
        if (typeof this.input === "string" && this.input.length === 10) {
            obj = fromString(this.input);
        }else if (typeof this.input === "string" && this.input.length === 8) {
            obj = fromStringfiedNumber(this.input);
        }else if (typeof this.input === "number" && this.input.toString().length === 8) {
            obj = fromNumber(this.input);
        } else if ((typeof this.input === "number" && this.input.toString().length >= 9 ) || typeof this.input === "object") {
            obj = fromObject(this.input);
        }
        if (this.format === "aaaa/mm/dd") {
            return obj.year + this.separator + obj.month + this.separator + obj.day;
        } else if (this.format === "mm/dd/aaaa") {
            return obj.month + this.separator + obj.day + this.separator + obj.year;
        } else {
            return obj.day + this.separator + obj.month + this.separator + obj.year;
        }
    };
}


// WEBPACK FOOTER //
// ./src/parser/DateParser.js